import React, { useContext, useEffect, useState } from "react";
import HeadingBanner from "../Components/HeadingBanner.jsx";
import Dashboard from "../Components/Dashboard.jsx";
import { Shimmer } from "react-shimmer";
import { notification_fun } from "../api/Dashboardapi.js";
import moment from "moment";
import { Modal } from "react-bootstrap";


const Notifycation = ({ settings }) => {


    const [notify_data, setnotify_data] = useState([])
    const [isloading, setisloading] = useState(true)

    const [showModal, setShowModal] = useState(false);
    const [profileImage, setProfileImage] = useState(null)


    const handleOpen = (image) => {
        setProfileImage(image);
        setShowModal(true);
    };

    const handleClose = () => {
        setShowModal(false);
        setProfileImage(null);
    };

    const getnotification = async () => {

        setisloading(true)

        notification_fun()
            .then((res) => {
                setnotify_data(res?.data);
                setisloading(false)
            })
            .catch((err) => {
                setisloading(false)
            });

    }



    useEffect(() => {
        moment.updateLocale('en', {
            relativeTime: {
                future: "in %s",
                past: "%s ",
                s: 'a few seconds',
                ss: '%d seconds',
                m: "a minute",
                mm: "%d minutes",
                h: "1 hour ", //this is the setting that you need to change
                hh: "%d hours",
                d: "a day",
                dd: "%d days",
                w: "a week",
                ww: "%d weeks",
                M: "1 month", //change this for month
                MM: "%d months",
                y: "a year",
                yy: "%d years"
            }
        });

        getnotification()
    }, [])

    return (
        <>
            <HeadingBanner title={"Notification"} />
            <section>
                <div className="container">
                    <div className="notifycation-layout">
                        <div className="row">
                            <div className="col-xl-3 col-lg-4 ">
                                <Dashboard setting_data={settings} />
                            </div>
                            <div className="col-xl-9 col-lg-8 ">
                                <div className="notifycation-content">
                                    <div className="notificatin-head pb-3">
                                        <h4>Notification</h4>
                                    </div>

                                    <div className="notify-list border py-3 px-md-5 px-2">
                                        <div >
                                            {isloading ?
                                                <div className="row notify-loader">
                                                    <div className="col-xl-2 col-lg-3 col-md-2 col-sm-4 col-6">
                                                        <div className="notify-img text-center my-sm-5 my-md-0">
                                                            <Shimmer className="rounded-circle" width={60} height={60} />
                                                        </div>
                                                    </div>
                                                    <div className="col-xl-10 col-lg-9 col-md-10 col-sm-8 col-6">
                                                        <div className="notify-section ">
                                                            <div className="notify-sec1 d-flex flex-wrap align-items-center justify-content-between">
                                                                <h4><Shimmer width={80} height={20} /></h4>
                                                                <h6><Shimmer width={30} height={15} /></h6>
                                                            </div>
                                                            <div className="notify-sec2">
                                                                <Shimmer width={400} height={40} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                :
                                                notify_data && notify_data.length > 0 ? notify_data.map((data, i) => {
                                                    return (
                                                        <div className="row" key={i}>
                                                            <div className="col-xl-2 col-lg-3 col-md-2 col-sm-4 col-4">
                                                                <div className="notify-img text-center my-sm-5 my-md-0" onClick={()=>handleOpen(data.image ? data?.image : " /assets/iocns/message_notification.jfif")}>
                                                                    {/* /assets/iocns/message_notification.jfif */}
                                                                    {/* /assets/images/dummy.png */}
                                                                    <img src={data.image ? data?.image : " /assets/iocns/message_notification.jfif"} className="img-fluid" alt="profile" />

                                                                </div>
                                                            </div>
                                                            <div className="col-xl-10 col-lg-9 col-md-10 col-sm-8 col-8">
                                                                <div className="notify-section ">
                                                                    <div className="notify-sec1 d-flex flex-wrap align-items-center justify-content-between">
                                                                        <h4>{data?.title}</h4>
                                                                        <h6>{moment(data?.updated_at).fromNow()}ago</h6>
                                                                    </div>
                                                                    <div className="notify-sec2">
                                                                        <p>{data?.description}</p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )
                                                }) :
                                                    <div className="text-center mt-5">
                                                        <h4> <strong>There is no new Notification</strong></h4>
                                                    </div>
                                            }
                                        </div>


                                        {/* Modal outside map — shared for all items */}
                                        <Modal show={showModal} onHide={handleClose} centered>
                                            <Modal.Header closeButton>
                                                
                                            </Modal.Header>
                                            <Modal.Body className="text-center">
                                                {profileImage && (
                                                    <img
                                                        src={profileImage}
                                                        alt="Preview"
                                                        style={{ maxWidth: "100%", maxHeight: "600px" }}
                                                    />
                                                )}
                                            </Modal.Body>
                                        </Modal>


                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </>
    )

}
export default Notifycation;